import {Component, AfterViewInit, EventEmitter, Output} from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbPanelChangeEvent, NgbCarouselConfig} from '@ng-bootstrap/ng-bootstrap';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {LoginService} from '../../core/login/login.service';
import {AccountService} from '../../singelton/account.service';
import {HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {TransactionService} from '../../entities/transaction/transaction.service';
import {ITransactionView} from '../model/transactionView.model';
import {EmployeeService} from '../../core/employee/employee.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {Employee} from '../model/employee.model';
import {ITransaction} from '../model/transaction.model';
import * as moment from 'jalali-moment';
import {EventService} from "../../singelton/event.service";
import {Router} from "@angular/router";
import {ProjectService} from "../../entities/project/project.service";
import {SalesCycle} from "../model/salesCycle.model";
import {SalesCycleService} from "../../entities/salesCycle/sales-cycle.service";
import {SHOW_STORE, SHOW_TICKET} from "../../app.constants";
import {TicketService} from "../../entities/ticket/ticket.service";
import {StockService} from "../../entities/stock/stock.service";
import {SettingUpdateComponent} from "../../entities/setting/setting-update.component";
import {FeatureFlagsService} from "../../singelton/feature-flags.service";


declare var $: any;

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements AfterViewInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  // business_tyep: any = BUSINESS_TYPE;
  show_ticket: any = SHOW_TICKET;

  firstName: string;
  lastName: string;
  email: string;
  counter_task: Number = 0;
  counter_my_open_ticket: Number = 0;
  counter_stock_order_point: Number = 0;
  counter_stock_alarm_point: Number = 0;
  counter_transaction_inProgress: Number = 0;
  counter_project_noFollowUp: Number = 0;
  counter_salesCycle_noFollowUp: Number = 0;

  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  term: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  employee: Employee;
  transactions: ITransaction[];
  public config: PerfectScrollbarConfigInterface = {};
  show_store = SHOW_STORE;

  constructor(private modalService: NgbModal, private loginService: LoginService, public accountService: AccountService,
              public transactionService: TransactionService,
              public projectService: ProjectService,
              public salesCycleService: SalesCycleService,
              public ticketService: TicketService,
              public stockService: StockService,
              public employeeService: EmployeeService,
              private spinner: NgxSpinnerService,
              private eventService: EventService,
              public router: Router,
              private featureFlags: FeatureFlagsService) {


    this.syncFeatureFlags();
    this.eventService.changeSettingEvantAdd.subscribe(() => {
      this.featureFlags.load();
      setTimeout(() => this.syncFeatureFlags(), 300);
    });
    this.eventService.transactionEventAdded.subscribe((data) => {
      // alert(' chang ----- -- >>   ' + JSON.stringify(data));
      this.getTaskNotification();
    });

    this.eventService.ticketEventAdded.subscribe((data) => {
      // alert(' chang ----- -- >>   ' + JSON.stringify(data));
      this.loadCountMyOpenTicket();
    });
    this.eventService.stockEventAdded.subscribe((data) => {
      // alert(' chang ----- -- >>   ' + JSON.stringify(data));
      this.loadCountStockAlarmPoint();
      this.loadCountStockOrderPoint();
    });
    this.eventService.salesEventAdded.subscribe((data) => {
      // alert(' chang ----- -- >>   ' + JSON.stringify(data));
      this.loadCountNoFollowUpSalesCycle();
      this.loadCountInProgressPastTransaction();

    });


    this.accountService.identity().then(d => {

      this.firstName = d.firstName;
      this.lastName = d.lastName;
      this.email = d.email;
    });
    // this.loadMyTask();
    // this.search(1);
    this.getTaskNotification();
    this.itemsPerPage = 4;
    this.page = 1;
    this.predicate = 'transaction.description';
    this.reverse = 'asc';
    if (!this.accountService.hasAnyAuthority(['ROLE_CLIENT'])) {

      this.loadCountInProgressPastTransaction();
      this.loadCountNoFollowUpProject();
      this.loadCountNoFollowUpSalesCycle();
      this.loadCountEmployeeOpenTicket();

    }
    else {
      this.loadCountMyOpenTicket();

    }
    this.loadCountStockOrderPoint();
    this.loadCountStockAlarmPoint();
  }


  public showSearch = false;

  syncFeatureFlags() {
    this.show_ticket = this.featureFlags.flags.showTicket;
    this.show_store = this.featureFlags.flags.showStore;
  }

  toggleSearch(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.showSearch = !this.showSearch;
    if (this.showSearch) {
      setTimeout(() => {
        const el = document.querySelector('.crm-nav-search__input') as HTMLInputElement;
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  closeSearch() {
    this.showSearch = false;
  }

  submitSearch() {
    if (!this.term || !String(this.term).trim()) {
      return;
    }
    this.closeSearch();
    this.search(0);
  }

  // This is for Notifications
  notifications: Object[] = [
    {
      round: 'round-danger',
      icon: 'ti-link',
      title: 'دشبورد',
      subject: '',
      time: ''
    },
    {
      round: 'round-success',
      icon: 'ti-calendar',
      title: 'رویدادهای امروز',
      subject: 'یادآوری رویدادهای ثبت شده',
      time: ''
    },
    {
      round: 'round-info',
      icon: 'ti-settings',
      title: 'تنظیمات',
      subject: '',
      time: ''
    }
    ,
    {
      round: 'round-primary',
      icon: 'ti-user',
      title: 'مخاطبین',
      subject: '',
      time: '9:00 AM'
    }
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: 'assets/images/users/1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung a song! See you at',
      time: '9:10 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am a singer!',
      time: '9:08 AM'
    },
    {
      useravatar: 'assets/images/users/4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  ngAfterViewInit() {
  }

  logout() {
    this.loginService.logout();
  }

  loadCountInProgressPastTransaction() {
    this.transactionService.findTransactionCountInProgressPast().subscribe(
      (res: HttpResponse<any>) => {
        this.counter_transaction_inProgress = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadCountNoFollowUpProject() {
    this.projectService.findProjectNoFollowUpCount().subscribe(
      (res: HttpResponse<any>) => {
        this.counter_project_noFollowUp = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  loadCountNoFollowUpSalesCycle() {
    this.salesCycleService.findSalesCycleNoFollowUpCount().subscribe(
      (res: HttpResponse<any>) => {
        this.counter_salesCycle_noFollowUp = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadCountMyOpenTicket() {
    this.ticketService.getMyOpenTicketCount().subscribe(
      (res: HttpResponse<any>) => {
        this.counter_my_open_ticket = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadCountStockAlarmPoint() {
    this.stockService.countAlarmPoint().subscribe(
      (res: HttpResponse<any>) => {
        this.counter_stock_alarm_point = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadCountStockOrderPoint() {
    this.stockService.countOrderPoint().subscribe(
      (res: HttpResponse<any>) => {
        this.counter_stock_order_point = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadCountEmployeeOpenTicket() {
    this.ticketService.getEmployeeOpenTicketCount().subscribe(
      (res: HttpResponse<any>) => {
        this.counter_my_open_ticket = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  public goToProject(status) {
    // alert('status='+status);
    this.router.navigate(['page/transaction-project-report', {
      project_status: (status ? status : ''),
      project_status_open: (status ? status : ''),
    }]);
  }

  public goToSalesCycle(status) {
    // alert('status='+status);
    this.router.navigate(['page/transaction-sales-cycle-report', {
      salesCycle_status: (status ? status : ''),
      salesCycle_status_open: (status ? status : ''),
    }]);
  }

  public goToTransaction(v) {
    // alert('status='+status);
    this.router.navigate(['page/transaction-report', {
      deadline_days: (v ? v : ''),
    }]);
  }

  public goToTicket(v) {
    // alert('status='+status);
    this.router.navigate(['page/tickets', {
      // deadline_days: (v ? v : ''),
    }]);
  }

  public goToStock(v) {
    // alert('status='+status);
    this.router.navigate(['page/stocks', {
      // deadline_days: (v ? v : ''),
    }]);
  }

  public goToSetting() {
    // alert('status='+status);
    this.router.navigate(['page/calendar', {
      // deadline_days: (v ? v : ''),
    }]);
  }


  loadMyTask() {
    this.accountService.identity().then(account => {
      const employeeId = account.id;
      this.transactionService.findMyTransactionCount(employeeId).subscribe(
        (res: HttpResponse<any>) => {
          this.counter_task = res.body;

        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    });

  }

  protected onError(errorMessage: string) {
  }


  getTaskNotification() {
    this.spinner.show();
    this.transactionService
      .getTransactionNotification({
        page: 0,
        size: 3,
        // sort: this.sort(),
      })
      .subscribe(
        (res: HttpResponse<ITransaction[]>) => this.paginateTransactions(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }

  search(page) {
    this.router.navigate(['/rapid-search/' + this.term]);
    this.spinner.hide();
  }

  sort() {
    let result = ['id, desc'];
    if (this.predicate) {
      result = [this.predicate + ',' + this.reverse];
      return result;
    }
  }

  protected paginateTransactions(data: ITransactionView[], headers: HttpHeaders) {
    // this.links = this.parseLinks.parse(headers.get('link'));
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    // alert('this.queryCount==' + this.queryCount);
    this.transactions = data;
    // this.loadPage(this.page);

    this.spinner.hide();
  }

  parseDate(value) {
    let jalaliDate5 = '-';
    if (value) {
      jalaliDate5 = moment(value).locale('fa').format('jYYYY/jM/jD');
    }
    return jalaliDate5;
  }


  public showProfile(data) {


    // this.router.navigate(['/page/profile-customer/', data]);


    const scrollHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );


  }


  openSetting() {
    const modalRef = this.modalService.open(SettingUpdateComponent, {windowClass: 'sm', backdrop: 'static'});
    modalRef.result.then(
      (result) => {
      }, (reason) => {
      }
    );
  }

}
